import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

const modules = {}

const state = {
	isMobileNavOpen: false,
	leagues: [],
	pages: [],
	listeners: [],
	activeLeagueKey: null,
	activeTeamKey: null,
	activePageName: null,
	activePageScheduleWeekId: null,
	activePageAlternateScheduleTeamKey: null,
	activePagePlayoffsBracket: true,
	activePagePlayoffsBracketRound: 0,
	activePageConsolationBracketRound: 0,
}

export default new Vuex.Store({
	strict: true,
	modules,
	state,
	getters,
	mutations,
	actions,
})
